import { Component, Input, OnInit } from '@angular/core';

import { GiftPrintBannerImageOption } from '../../../../../../../../models/gift';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../../utils';
import { GiftService } from '../../../../../../../../services/gift/gift.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-configure-gift-print-banner-image-option-modal',
  templateUrl: './configure-gift-print-banner-image-option-modal.component.html',
  styleUrls: ['./configure-gift-print-banner-image-option-modal.component.css']
})
export class ConfigureGiftPrintBannerImageOptionModalComponent implements OnInit {
  @Input() opt: GiftPrintBannerImageOption = null;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public isNewOption: boolean;

  public imageFileData: File = null;

  public serverError: number = null;
  public errorMessage = '';
  public errors: any = {};
  public savingOption = false;

  constructor(
    public activeModal: NgbActiveModal,
    private giftService: GiftService,
  ) {}

  ngOnInit() {
    this.isNewOption = this.opt === null;
    if (this.isNewOption) {
      this.opt = {
        id: null,
        url: '',
        name: '',
        image: null,
        created_at: null,
        updated_at: null,
      }
    } else {
      this.opt = {...this.opt};
    }
  }

  public attachImageFile(event) {
    this.imageFileData = event.target.files[0] as File;
    if (this.imageFileData.type.match(/image\/*/) == null) {
      this.errors.image = 'Invalid image file.';
      this.imageFileData = null;
      return;
    }
    if (this.imageFileData.size > 4194304) {
      this.errors.image = 'Image file is larger than 4 MB.';
      this.imageFileData = null;
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(this.imageFileData);
    reader.onload = () => {
      this.opt.image = reader.result as string;
    };
  }

  public saveOption() {
    this.savingOption = true;

    this.errorMessage = '';
    this.errors = {};

    let savePromise: Promise<GiftPrintBannerImageOption>;
    if (this.isNewOption) {
      savePromise = this.giftService.createGiftBannerImageOption(
        this.opt,
        this.imageFileData
      );
    } else {
      savePromise = this.giftService.updateGiftBannerImageOption(
        this.opt,
        this.imageFileData
      );
    }

    savePromise
      .then(updatedOpt => {
        this.savedCallback({
          text: updatedOpt.name + ' saved successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to take this action.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.savingOption = false; });
  }
}
